export enum PreviewTooltipDataHooks {
  TOOLTIP = 'tooltip',
  TOOLTIP_WRAPPER = 'tooltip-wrapper',
}
